import React from "react";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";
import dashboardSettingsStore from "../../stores/dashboard-settings-store";

/**
 * ProtectedRoute checks whether the current route path is available/ accessible based on permissions.
 * The provided element is rendered only if permissions allow entering the route.
 * 
 * @param el - The React node to render if the path is available
 */
export const ProtectedRoute: React.FC<{ el: React.ReactNode }> = observer(({ el }) => {
    const location = useLocation();

    /**
     * This is to avoid showing "This page is not allowed" right away after the user opens a page
     */
    if (!dashboardSettingsStore.areSettingsLoaded) {
        return null;
    }

    if (!dashboardSettingsStore.isPathAvailable(location.pathname)) {
        return <>This page is not allowed</>;
    }

    return <>{el}</>;
});